module.exports = __webpack_public_path__ + "img/1.f7cb71f0.png";